import styled, { css, FlattenInterpolation, ThemedStyledProps } from 'styled-components/macro';
import { PopoverSizes } from '..';
import { PopoverName } from 'shared/enums/PopoverName';

interface IPopoverContentProps {
  borderWidth?: PopoverSizes | 'none';
  name?: string;
  isMobile?: boolean;
}

const spacingSizes = {
  none: '0',
  xxxs: '0.125rem', // 2px
  xxs: '0.25rem', // 4px
  xs: '0.5rem', // 8px
  sm: '0.75rem', // 12px
  md: '1rem', // 16px
  lg: '1.5rem', // 24px
  xl: '2rem', // 32px
  xxl: '2.5rem', // 40px
  xxxl: '3rem', // 48px
};

const getPaddingFromBorderWidth = (borderWidth?: PopoverSizes | 'none'): string =>
  borderWidth ? spacingSizes[borderWidth] : '0.875rem';

const defaultStyles = css<IPopoverContentProps>`
  padding: ${({ borderWidth }: IPopoverContentProps): string => {
    return `${getPaddingFromBorderWidth(borderWidth)} ${getPaddingFromBorderWidth(borderWidth)}`;
  }};
`;

const mobilePhoneCallStyles = css`
  padding-top: 20px;
`;

const mobileVideoCallStyles = css`
  padding: 0;
`;

/* eslint-disable @typescript-eslint/no-explicit-any */
const PopoverContent = styled.div<IPopoverContentProps>`
  ${({ name, isMobile }: IPopoverContentProps): FlattenInterpolation<ThemedStyledProps<IPopoverContentProps, any>> => {
    if (isMobile && name === PopoverName.PhoneCall) return mobilePhoneCallStyles;
    if (isMobile && name === PopoverName.VideoCall) return mobileVideoCallStyles;
    return defaultStyles;
  }}};
`;
/* eslint-enable @typescript-eslint/no-explicit-any */

export default PopoverContent;
